import styled from 'styled-components';

import AIIcon from '@/components/Badge/AIBadge/AIIcon';
import Tooltip from '@/components/Tooltip/TooltipV2';
import Typo from '@/components/Typography/Typo';
import { cn } from '@/lib/cn';
import { useMessage } from '@/messages';

type Props = {
  simple?: boolean;
  className?: string;
};

const AIBadge = (props: Props) => {
  const m = useMessage();
  return (
    <>
      {props.simple ? (
        <Tooltip tooltipNode={m.common('BY_AI')}>
          <AIIcon className={cn('text-base', props.className)} />
        </Tooltip>
      ) : (
        <Style
          data-tooltip-id="ai-badge-tooltip"
          data-tooltip-content={m.common('BY_AI')}
          className={props.className}
        >
          <AIIcon />
          <Typo>AI</Typo>
        </Style>
      )}
    </>
  );
};

const Style = styled.span`
  width: 44px;
  padding-right: 4px;
  height: 16px;
  border-radius: 6px;
  color: ${(props) => props.theme.colors.FL100};
  background-color: ${(props) => props.theme.colors.green500};
`;

export default AIBadge;
